import { gql, useQuery } from '@apollo/client';
import { Grid } from '@mui/material';
import fragments from 'services/fragments';
import SummaryEvents from './SummaryEvents';
import SummaryServiceOrders from './SummaryServiceOrders';
import { SummaryTimeline } from 'types/timeline.types';
import { useNavigate } from 'react-router-dom';
import React from 'react';
import { useRecoilValue } from 'recoil';
import { accountSelectedSelector } from 'atoms';
import { SummaryServiceOrder } from 'types/serviceOrder.types';

const ACCOUNTS_OVERVIEW = gql`
  ${fragments.Events}
  ${fragments.ServiceOrders}
  query GetAccountsOverview {
    getAccountsOverview {
      events {
        ...EventsProperties
      }
      serviceOrders {
        ...ServiceOrderProperties
      }
    }
  }
`;

function SummaryPage() {
  const accountSelected = useRecoilValue(accountSelectedSelector);
  const navigate = useNavigate();
  const { data, error, loading } = useQuery<{
    getAccountsOverview: {
      events: SummaryTimeline[];
      serviceOrders: SummaryServiceOrder[];
    };
  }>(ACCOUNTS_OVERVIEW);

  React.useEffect(
    function whenSelectAnAccount() {
      if (accountSelected) {
        navigate('/');
      }
    },
    [accountSelected, navigate],
  );

  if (error) {
    throw error;
  }

  return (
    <Grid container spacing={2} height="100%">
      <Grid
        item
        xs={12}
        md={6}
        sx={{ maxHeight: '100%', display: 'flex', flexDirection: 'column' }}
      >
        <SummaryEvents events={data?.getAccountsOverview?.events} loading={loading} />
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
        sx={{ maxHeight: '100%', display: 'flex', flexDirection: 'column' }}
      >
        <SummaryServiceOrders
          serviceOrders={data?.getAccountsOverview?.serviceOrders}
          loading={loading}
        />
      </Grid>
    </Grid>
  );
}

export default SummaryPage;
